<footer class="page-footer">
    <div class="page-footer-links">
        <a matButton="text" [routerLink]="imprintLink()">Impressum</a>
        <a matButton="text" [routerLink]="dataProtectionLink()">Datenschutz</a>
    </div>
    <app-base-text [text]="copyright()" [gotham]="true"></app-base-text>
    <img src="/icon-192.png" />
</footer>
